/**
 * The session's CSRF token, kept in memory only. It comes from the login response and
 * from /auth/me (so it survives a reload); the session itself is the httpOnly cookie.
 */
let csrfToken: string | null = null

export function setCsrfToken(token: string | null): void {
    csrfToken = token
}

export function getCsrfToken(): string | null {
    return csrfToken
}
